import { render, staticRenderFns } from "./letter-template-config.vue?vue&type=template&id=a6559220"
import script from "./letter-template-config.vue?vue&type=script&lang=ts"
export * from "./letter-template-config.vue?vue&type=script&lang=ts"
import style0 from "./letter-template-config.vue?vue&type=style&index=0&id=a6559220&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports